import { ofType } from "redux-observable";
import { empty, from, of } from "rxjs";
import { mergeMap, catchError } from "rxjs/operators";
import logger, { customErrorObject, ErrorType } from "../services/logging/Logger.js";
import { newGuid } from "../services/GuidHelper.js";
const innerLoadLoadingLoadedEpic = (args) => {
  const {
    payload,
    state$,
    loadResource,
    loadedAction,
    loadingAction,
    dontLoad = () => false,
    ensureSuccess = false,
    skiploadDataTransform = false
  } = args;
  const dontLoadResult = dontLoad(payload, state$ && state$.value);
  if (dontLoadResult) {
    return typeof dontLoadResult === "boolean" ? empty() : dontLoadResult;
  }
  let callLoadResource = () => {
    try {
      let res = loadResource(payload, state$ && state$.value);
      let withError = res.catch((pex) => {
        let rethrow = customErrorObject(pex, "callLoadResourcePromiseError");
        logger.error(rethrow, ErrorType.CallLoadResourcePromiseError, {
          errorCorrelationId: rethrow.errorCorrelationId,
          thrownFrom: rethrow.thrownFrom,
          promiseError: rethrow,
          suppressPopup: true
        });
        throw rethrow;
      });
      return withError;
    } catch (ex) {
      let rethrow = customErrorObject(ex, "callLoadResourceException");
      logger.error(rethrow.message, ErrorType.CallLoadResourceError, {
        errorCorrelationId: rethrow.errorCorrelationId,
        thrownFrom: rethrow.thrownFrom,
        promiseError: rethrow,
        suppressPopup: true
      });
      throw rethrow;
    }
  };
  const loadResourceComplete = from(callLoadResource()).pipe(
    mergeMap((result) => {
      var _a, _b;
      const errorCorrelationId = newGuid();
      try {
        {
          let successData = result;
          if (!skiploadDataTransform) {
            const restResult = result;
            if (!!restResult) {
              if (typeof restResult.isSuccessful === "function") {
                if (!ensureSuccess && !restResult.isSuccessful()) {
                  const error = ((_a = restResult == null ? void 0 : restResult.errorContext) == null ? void 0 : _a.displayError) || restResult.error || "[unset]";
                  const errorContext2 = restResult == null ? void 0 : restResult.errorContext;
                  logger.error(error, ErrorType.LoadResourceCompleteUnsuccessful, {
                    errorCorrelationId,
                    errorContext: errorContext2,
                    suppressPopup: true
                  });
                  return loadedAction(
                    // @ts-ignore
                    void 0,
                    payload,
                    error,
                    errorContext2,
                    state$ && state$.value
                  );
                }
              }
              if (typeof restResult.getSuccessData === "function") {
                try {
                  successData = restResult.getSuccessData();
                } catch (ex) {
                  const error = ((_b = restResult == null ? void 0 : restResult.errorContext) == null ? void 0 : _b.displayError) || restResult.error || "[unset]";
                  const errorContext2 = restResult == null ? void 0 : restResult.errorContext;
                  logger.error(error, ErrorType.LoadResourceCompleteGetSuccessDataException, {
                    errorCorrelationId,
                    errorContext: errorContext2,
                    suppressPopup: true
                  });
                  throw ex;
                }
              }
            }
          }
          let errorContext;
          try {
            errorContext = result == null ? void 0 : result.errorContext;
          } catch (e) {
          }
          return loadedAction(successData, payload, void 0, errorContext, state$ && state$.value);
        }
      } catch (ex) {
        let rethrow = customErrorObject(ex, "loadResourceCompleteException");
        throw rethrow;
      }
    }),
    catchError((error) => {
      logger.error(error, ErrorType.LoadResourceComplete);
      return loadedAction(
        // @ts-ignore
        null,
        payload,
        !error ? "unknown error" : error.message,
        { errorCorrelationId: error.errorCorrelationId, notificationHandled: error.notificationHandled },
        state$ && state$.value
      );
    })
  );
  const loading = of(loadingAction(payload));
  return of(loading, loadResourceComplete).pipe(mergeMap((x) => x));
};
const produceLoadLoadingLoadedEpic = (args) => {
  const {
    filterOnType,
    loadResource,
    loadedAction,
    loadingAction,
    dontLoad = () => false,
    ensureSuccess = false,
    skiploadDataTransform = false
  } = args;
  return (action$, state$) => {
    return action$.pipe(
      ofType(filterOnType),
      mergeMap(
        (action) => innerLoadLoadingLoadedEpic({
          payload: action.payload,
          state$,
          loadResource,
          loadingAction,
          loadedAction,
          dontLoad,
          ensureSuccess,
          skiploadDataTransform
        })
      )
    );
  };
};
export {
  innerLoadLoadingLoadedEpic,
  produceLoadLoadingLoadedEpic
};
//# sourceMappingURL=ReduxObservablesEpicUtils.js.map
